
// The MXF PrimerPack is located in the header partition or in the footer
// partition. The PrimerPack defines the mapping from the shorter two-byte
// LocalTags to the longer 16-byte ULs. These shorter two-byte LocalTags
// are used when parsing structural metadata and IndexTableSegments.

import { MultiArrayBuffer } from './multiArrayBuffer';
import { Parser } from './parser';

export interface PrimerPackEntry {
  localTag: string,
  ul: string
}

export function parsePrimerPack(bytes: Uint8Array): PrimerPackEntry[] {
  const source = new MultiArrayBuffer();
  source.push(bytes);

  const parser = new Parser(source);

  const count = parser.readUInt32BE();
  const expectedSize = parser.readUInt32BE();

  const localTagEntries = [];
  for (let i = 0; i < count; i++) {
    const start = parser.remain();
    const localTag = parser.readLocalTag();
    const ul = parser.readUl();
    localTagEntries.push({ localTag, ul });
    const end = parser.remain();
    const size = start - end;
    if (size !== expectedSize) {
      throw new Error(`Invalid Primer pack entry size: ${size}. Expected ${expectedSize}`);
    }
  }
  return localTagEntries;
}

